import { Navigate, useParams } from 'react-router-dom';
import { MarketingDetailPage } from '@/modules/marketing/components/marketing-detail-page';
import { PLATFORM_FEATURES, PlatformPreviewVisual } from '@/modules/marketing/components/platform-visuals';

export function PlatformDetailPage() {
    const { slug } = useParams<{ slug: string }>();
    const feature = PLATFORM_FEATURES.find((f) => f.slug === slug);

    if (!feature) {
        return <Navigate to="/" replace />;
    }

    return (
        <MarketingDetailPage
            backLabel="Data & Analysis"
            backHref="/#products"
            visual={<PlatformPreviewVisual icon={feature.icon} size="lg" />}
            content={{
                eyebrow: 'Data & Analysis',
                icon: feature.icon,
                gradient: 'from-[#4c1d95] to-[#8b5cf6]',
                title: feature.title,
                tagline: feature.tagline,
                description: feature.description,
                bullets: feature.bullets,
            }}
        />
    );
}
